export default [
    {
        name: 'siteAbout',
        path: '/site/about',
        component: require('@/pages/SiteAbout').default,
        meta: {
            back: { label: 'Dashboard', to: '/' }
        }
    },
    {
        name: 'siteFAQ',
        path: '/site/faq',
        component: require('@/pages/SiteFAQ').default,
        meta: {
            back: { label: 'Dashboard', to: '/' }
        }
    },
    {
        name: 'sitePrivacy',
        path: '/site/privacy',
        component: require('@/pages/SitePrivacy').default,
        meta: {
            back: { label: 'Dashboard', to: '/' }
        }
    },
    {
        name: 'siteSystem',
        path: '/site/system',
        component: require('@/pages/SiteSystem').default,
        meta: {
            back: { label: 'Dashboard', to: '/' }
        }
    },
]
